import Vue from 'vue'

export const cart = {
  namespaced: true,
  state: {
    items: {},
    totalPrice: 0,
  },
  mutations: {
    itemsFirstSet(state, payload) {
      let totalPrice = 0

      for (let i = 0; i < payload.length; i++) {
        Vue.set(state.items, 'order_' + payload[i].page.order, payload[i])

        if (payload[i].priceIncTax) {
          let num = String(payload[i].priceIncTax)
          num = Number(num.replace(/,/g, ''))
          totalPrice = totalPrice + num
        }
      }
      totalPrice = String(totalPrice).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      Vue.set(state, 'totalPrice', totalPrice)
    },
    itemsSet(state, payload) {
      if (payload.page) payload.page.order = payload.page.order.replace('.', '-')

      if (payload.state) {
        Vue.set(state.items, payload.orderName, payload.item)
      } else {
        Vue.delete(state.items, payload.orderName)
      }
      cart.mutations.totalPriceCalc(state)
    },
    stagesReset(state, payload) {
      for (let key in state.items) {
        let num = key.split('_')
        num = Number(num[1].replace('-', '.'))
        if (num > 3) {
          Vue.delete(state.items, key)
        }
      }
    },
    itemsReset(state) {
      state.items = {}
      state.totalPrice = 0
    },
    totalPriceCalc(state) {
      let totalPrice = 0

      Object.keys(state.items).forEach((key) => {
        if (state.items[key].priceIncTax) {
          let num = String(state.items[key].priceIncTax)
          num = Number(num.replace(/,/g, ''))
          totalPrice = totalPrice + num
        }
      })
      totalPrice = String(totalPrice).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');

      Vue.set(state, 'totalPrice', totalPrice)
    },
  },
}
